// extracted by mini-css-extract-plugin
module.exports = {"revertDocValue":"RevertDocValue-module__revertDocValue___3QzkH","innerContainer":"RevertDocValue-module__innerContainer___1pjDC","button":"RevertDocValue-module__button___2Q0KO"};